import { useQueries } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { BoosterBackend } from "types/Booster";
import { api } from "utils/hostname";
import url from "../url";

const request = (id: string | number) =>
  api(true, true).get(url.config.api.loyalty.boosterInfo(id));

export const useInfoBoosters = (
  idsBoosters: string[],
  enabled?: boolean,
): BoosterBackend[] => {
  const queries = idsBoosters?.map((idBooster) => ({
    queryKey: ["booster info", idBooster],
    queryFn: () => request(idBooster),
    enabled: !!idBooster && !!enabled,
    staleTime: Infinity,
  }));

  return (
    useQueries<
      Array<AxiosResponse<{ data: { data: { data: BoosterBackend } } }>>,
      BoosterBackend[]
    >({
      queries,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      combine: (result) => {
        return (
          result
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            .map((res) => res?.data?.data?.data)
            .filter((res) => !!res)
        );
      },
    }) || []
  );
};
